import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import logoImage from './images/logo.jpg';  
import psdfimage from './images/psdfimage.png'; 

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'jo_date', numeric: false, label: 'Date', disablePadding: true },
    { id: 'le_ledgername', numeric: false, label: 'Ledger Name', disablePadding: true },
    { id: 'jo_reference', numeric: false, label: 'Ref', disablePadding: true },
    { id: 'jo_description', numeric: false, label: 'Memo/Description', disablePadding: true },
    { id: 'jr_debit', numeric: true, label: 'Debit', disablePadding: true },
    { id: 'jr_credit', numeric: true, label: 'Credit', disablePadding: true },
    { id: 'running_balance', numeric: true, label: 'Balance', disablePadding: true },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rowCount } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export default class GeneralLedgerReport extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            redirect: false,
            pagename: '',
            ReportData: [],
            totaldata: 0,
            page: 0,
            rowsPerPage: 20,
            ledger_id: '',
            search: '',
            order: 'desc',
            orderBy: 'jo_date',
            fromdate: dayjs(currentDate).startOf('month'),
            todate: dayjs(currentDate),
            fromdate1: dayjs(currentDate).startOf('month').format('YYYY-MM-DD'),
            todate1: dayjs(currentDate).format('YYYY-MM-DD'),
            openExportDialog: false,
            ledgerName: '', 
        };
    }

    componentDidMount() {
        document.title = "General Ledger Report";
        
        if (localStorage.getItem("ISIuserid") == null) {
            this.setState({ redirect: true, pagename: "/Login" });
            return;
        }

        const fullUrl = window.location.href;
        const hashIndex = fullUrl.indexOf('#');
        let pathname = '/GeneralLedgerReport';
        let search = '';
        
        if (hashIndex !== -1) {
            const afterHash = fullUrl.substring(hashIndex + 1);
            const questionIndex = afterHash.indexOf('?');
            if (questionIndex !== -1) {
                pathname = afterHash.substring(0, questionIndex);
                search = afterHash.substring(questionIndex);
            } else {
                pathname = afterHash;
            }
        }
        
      const urlParams = new URLSearchParams(search);

const ledgerParam = urlParams.get("ledger_id");
const fromdateParam = urlParams.get("fromdate");
const todateParam = urlParams.get("todate");

const ledger_id = ledgerParam ? parseInt(ledgerParam, 10) : 0;

this.setState({
    ledger_id,
    fromdate: fromdateParam ? dayjs(fromdateParam) : this.state.fromdate,
    todate: todateParam ? dayjs(todateParam) : this.state.todate,
    fromdate1: fromdateParam || this.state.fromdate1,
    todate1: todateParam || this.state.todate1
}, () => {
    this.fetchReportData(0, 20);
});
    }

    fetchReportData = async (page, rowsPerPage) => {
        const { fromdate1, todate1, ledgerName, order, orderBy, ledger_id } = this.state;
        const startIndex = page * rowsPerPage;
        
        const apiUrl = localStorage.getItem("ISIurl") +
            'ajaxledger.php?action=generalledreport' +
            '&fromdate=' + fromdate1 +
            '&todate=' + todate1 +
            '&ledger_id=' + ledger_id +     
            '&cmp_id=' + localStorage.getItem("ISIcmpid") +
            '&ledgername=' + encodeURIComponent(ledgerName) +
            '&StartIndex=' + startIndex +
            '&PageSize=' + rowsPerPage +
            '&order=' + order +
            '&orderBy=' + orderBy;
            
        const resp = await axios.get(apiUrl);
        let data = Array.isArray(resp.data) ? resp.data : [];
        this.setState({
            ReportData: data,
            totaldata: parseInt(resp.data[0]?.count || data.length)
        });
    };

    handleSearch = () => {
        this.fetchReportData(0, this.state.rowsPerPage);
    };

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc',
            page: 0
        }, () => {
            this.fetchReportData(0, this.state.rowsPerPage);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.fetchReportData(newPage, this.state.rowsPerPage);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        }, () => {
            this.fetchReportData(0, parseInt(event.target.value));
        });
    };

    getLedgerIdFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get("ledger_id") || 0;
    };

    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    fromdatehandler = (date) => {
        this.setState({
            fromdate: dayjs(date),
            fromdate1: dayjs(date).format('YYYY-MM-DD')
        });
    };

    todatehandler = (date) => {
        this.setState({
            todate: dayjs(date),
            todate1: dayjs(date).format('YYYY-MM-DD')
        });
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        return dayjs(dateString).format('MM-DD-YYYY');
    };

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

    handleDownloadPDF = () => {
        const { ReportData } = this.state;
        const doc = new jsPDF();
        const imgWidth = 40;
        const imgHeight = 12;
        const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
        doc.addImage(logoImage, 'JPEG', imgX, 22, imgWidth, imgHeight);
        doc.setFontSize(16);
        doc.text('General Ledger Report', 14, 40);
        const headers = [['Ledger Name', 'Date', 'Ref', 'Memo/Description', 'Debit', 'Credit', 'Balance']];
        const rows = ReportData.map(item => [
            item.le_ledgername || '',
            this.formatDate(item.jo_date),
            item.jo_reference || '',
            item.jo_description || '',
            parseFloat(item.jr_debit || 0).toFixed(2),
            parseFloat(item.jr_credit || 0).toFixed(2),
            parseFloat(item.running_balance || 0).toFixed(2)
        ]);
        doc.autoTable({
            head: headers,
            body: rows,
            startY: 50,
            theme: 'striped',
            didDrawPage: function (data) {
                doc.setFontSize(10);
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });
        doc.save('GeneralLedgerReport.pdf');
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} />;
        }

        const { ReportData, order, orderBy, page, rowsPerPage, totaldata, openExportDialog } = this.state;
        const visibleRows = stableSort(ReportData, getSorting(order, orderBy));

        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
					{/*  <li>
                            <p>Ledger Name</p>
                            <TextField
                                variant="outlined"
                                fullWidth
                                className="txtbox"
                                value={this.state.ledgerName}
                                name="ledgerName"
                                onChange={this.myChangeHandler}
                                InputProps={{
                                    endAdornment: <SearchOutlinedIcon style={{ marginLeft: 8 }} />,
                                }}
                            />
	</li>  */}                
                        <li>
                            <p>From Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        value={this.state.fromdate}
                                        onChange={this.fromdatehandler}
                                        format="MM/DD/YYYY"
										disabled={true}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>To Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        value={this.state.todate}
                                        onChange={this.todatehandler}
                                        format="MM/DD/YYYY"
										disabled={true}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <Button variant="contained" className="exportbtn" onClick={this.handleSearch}>
                                Search
                            </Button>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <Button
                                variant="contained"
                                color="primary"
                                className="exportbtn"
                                onClick={this.handleOpenExportDialog}
                            >
                                EXPORT
                            </Button>
                        </li>
                    </ul>
                </div>

                <TableContainer>
                    <Table id="generalledgerreport">
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={ReportData.length}
                        />
                        <TableBody>
                            {totaldata === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No Records
                                    </TableCell>
                                </TableRow>
                            ) : (
                                visibleRows.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{this.formatDate(item.jo_date)}</TableCell>
                                        <TableCell>{item.le_ledgername}</TableCell>
                                        <TableCell>{item.jo_reference}</TableCell>
                                        <TableCell>{item.jo_description}</TableCell>
                                        <TableCell align="right">
                                            {parseFloat(item.jr_debit || 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell align="right">
                                            {parseFloat(item.jr_credit || 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell align="right">
                                            <b>{parseFloat(item.running_balance || 0).toFixed(2)}</b>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[20, 50, 100, 200]}
                    component="div"
                    count={totaldata}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                />

                <Dialog open={openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Export General Ledger Report</DialogTitle>
                    <DialogContent>
                        <p>Choose export format:</p>
                        <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
                            <ReactHTMLTableToExcel
                                id="test-table-xls-button"
                                className="my-custom-excel-button"
                                table="generalledgerreport"
                                filename="GeneralLedgerReport"
                                sheet="General Ledger"
                               
                            />
							<img
                                src={psdfimage}
                                width={100}
                                height={100}
                                style={{ cursor: "pointer" }}
                                onClick={this.handleDownloadPDF}
                                alt="PDF"
                                title="Download PDF"
                            />
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}